// src/api/farm-service/experienceService.js
import client from '../client';

const FARMS = '/api/farms';
const EXP = '/api/experiences';

// ── Admin ─────────────────────────────────────────────────────────────────────

/** POST /farms/:farmId/experiences */
export function createExperience(farmId, payload, location) {
  const body = { experience: payload };
  if (location) body.location = location;
  return client.post(`${FARMS}/${farmId}/experiences`, body);
}

/** PATCH /farms/:farmId/experiences/:experienceId */
export function updateExperience(farmId, experienceId, payload, location) {
  const body = { experience: payload };
  if (location) body.location = location;
  return client.patch(`${FARMS}/${farmId}/experiences/${experienceId}`, body);
}

/** PATCH /farms/:farmId/experiences/:experienceId/location */
export function updateExperienceLocation(farmId, experienceId, payload) {
  return client.patch(`${FARMS}/${farmId}/experiences/${experienceId}/location`, payload);
}

/** GET /farms/:farmId/experiences */
export function listByFarmId(farmId, params = {}) {
  return client.get(`${FARMS}/${farmId}/experiences`, { params });
}

// ── Image Upload ──────────────────────────────────────────────────────────────

/** POST /farms/:farmId/experiences/:experienceId/image/upload-url */
export function initiateExperienceImageUpload(farmId, experienceId, payload) {
  return client.post(`${FARMS}/${farmId}/experiences/${experienceId}/image/upload-url`, payload);
}

/** POST /farms/:farmId/experiences/:experienceId/image/:imageId/confirm-cover-image */
export function confirmExperienceCoverImage(farmId, experienceId, imageId) {
  return client.post(`${FARMS}/${farmId}/experiences/${experienceId}/image/${imageId}/confirm-cover-image`);
}

/** POST /farms/:farmId/experiences/:experienceId/images/confirm-gallery */
export function confirmExperienceGallery(farmId, experienceId, imageIds) {
  return client.post(`${FARMS}/${farmId}/experiences/${experienceId}/images/confirm-gallery`, { imageIds });
}

// ── Itinerary Image Upload ────────────────────────────────────────────────────

/** POST /farms/:farmId/experiences/:experienceId/itinerary/:itemId/image/upload-url */
export function initiateItineraryItemImageUpload(farmId, experienceId, itemId, payload) {
  return client.post(`${FARMS}/${farmId}/experiences/${experienceId}/itinerary/${itemId}/image/upload-url`, payload);
}

/** POST /farms/:farmId/experiences/:experienceId/itinerary/:itemId/image/:imageId/confirm */
export function confirmItineraryItemImageUpload(farmId, experienceId, itemId, imageId) {
  return client.post(`${FARMS}/${farmId}/experiences/${experienceId}/itinerary/${itemId}/image/${imageId}/confirm`);
}

// ── Admin / Public ────────────────────────────────────────────────────────────

/** GET /experiences/:experienceId/image/cover-image */
export function getCoverImageByExperienceId(experienceId) {
  return client.get(`${EXP}/${experienceId}/image/cover-image`);
}

/** GET /experiences/:experienceId/images/bulk-gallery */
export function getImagesByExperienceId(experienceId) {
  return client.get(`${EXP}/${experienceId}/images/bulk-gallery`);
}

/** GET /experiences/:experienceId/itinerary/:itemId/image */
export function getItineraryItemImage(experienceId, itemId) {
  return client.get(`${EXP}/${experienceId}/itinerary/${itemId}/image`);
}

// ── Public ────────────────────────────────────────────────────────────────────

/** GET /experiences/public/cards */
export function listPublicCards() {
  return client.get(`${EXP}/public/cards`);
}

/** POST /experiences/search */
export function searchPublic(payload) {
  return client.post(`${EXP}/search`, payload);
}

/** GET /experiences/:id */
export function getById(id) {
  return client.get(`${EXP}/${id}`);
}
